import React, { useState } from 'react';
import {
    Paper,
    Typography,
    Grid,
    TextField,
    Button,
    Box,
    Divider,
} from '@mui/material';
import { useApiHandler } from '../../hooks/useApiHandler';
import DashboardLayout from '../../components/layouts/DashboardLayout';

const FranchiseProfile = () => {
    const { showSuccess } = useApiHandler();
    const [isEditing, setIsEditing] = useState(false);
    const [profile, setProfile] = useState({
        name: 'City Express',
        ownerName: 'Mike Johnson',
        email: 'mike@cityexpress.com',
        phone: '1234567890',
        location: 'New York',
        address: '789 Broadway St',
        // Fields that can't be edited
        franchiseId: 'FR001',
        registrationDate: '2024-01-01',
        activeShipments: 150,
        totalRevenue: '$25,000',
        status: 'Active',
    });

    const [formData, setFormData] = useState(profile);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = () => {
        setProfile(formData);
        setIsEditing(false);
        showSuccess('Franchise profile updated successfully');
        // TODO: API call to update profile
    };

    return (
        <DashboardLayout title="Franchise Profile" userType="franchise">
            <Paper sx={{ p: 3 }}>
                <Box sx={{ mb: 3 }}>
                    <Typography variant="h5" gutterBottom>
                        Franchise Information
                    </Typography>
                    <Typography color="textSecondary">
                        Manage your franchise profile
                    </Typography>
                </Box>

                <Divider sx={{ mb: 3 }} />

                <Grid container spacing={3}>
                    {/* Read-only fields */}
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Franchise ID"
                            value={profile.franchiseId}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Registration Date"
                            value={profile.registrationDate}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Active Shipments"
                            value={profile.activeShipments}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Total Revenue"
                            value={profile.totalRevenue}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Status"
                            value={profile.status}
                            disabled
                        />
                    </Grid>

                    {/* Editable fields */}
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Franchise Name"
                            name="name"
                            value={isEditing ? formData.name : profile.name}
                            onChange={handleChange}
                            disabled={!isEditing}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Owner Name"
                            name="ownerName"
                            value={isEditing ? formData.ownerName : profile.ownerName}
                            onChange={handleChange}
                            disabled={!isEditing}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Email"
                            name="email"
                            type="email"
                            value={isEditing ? formData.email : profile.email}
                            onChange={handleChange}
                            disabled={!isEditing}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Phone"
                            name="phone"
                            value={isEditing ? formData.phone : profile.phone}
                            onChange={handleChange}
                            disabled={!isEditing}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Location"
                            name="location"
                            value={isEditing ? formData.location : profile.location}
                            onChange={handleChange}
                            disabled={!isEditing}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Address"
                            name="address"
                            multiline
                            rows={2}
                            value={isEditing ? formData.address : profile.address}
                            onChange={handleChange}
                            disabled={!isEditing}
                        />
                    </Grid>
                </Grid>

                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    {isEditing ? (
                        <>
                            <Button onClick={() => setIsEditing(false)}>
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                onClick={handleSubmit}
                            >
                                Save Changes
                            </Button>
                        </>
                    ) : (
                        <Button
                            variant="contained"
                            onClick={() => setIsEditing(true)}
                        >
                            Edit Profile
                        </Button>
                    )}
                </Box>
            </Paper>
        </DashboardLayout>
    );
};

export default FranchiseProfile; 